import axios from 'axios';
import {
  SHOW_FORM,
  SET_FORM_CUSTOM_SERVICE,
  UPDATE_ERROR,
  SET_FORM_FCL_SHIPPING,
  SET_FORM_PICKUP_JSON,
  SET_FORM_PICKUP_EXTRA,
  UPDATE_FORM_TAB_PANE,
  TOGGLE_LCL_SHIPPING_TYPE,
  SET_LCL_TOTAL_SHIPMENT,
  SET_LCL_BOX_PALLET,
  DELETE_LCL_BOX_PALLET,
  DELETE_FCL_SHIPPING,
  FORM_SUBMIT_SUCCESS,
  SET_PICKUP_EXISTING_FACTORY,
  SET_FORM_DELIVERY_JSON,
  SET_DELIVERY_EXISTING_FACTORY,
  SET_FORM_DELIVERY_EXTRA,
  SET_PICKUP_SELECTED_EXISTING_FACTORY,
  SET_DELIVERY_SELECTED_EXISTING_FACTORY,
  SET_LOAD_SUMMARY_TEXT,
  SET_QUERY_PARAMS,
  SET_LOAD_SUMMARY_LCL,
  RESET_LOAD_SUMMARY_LCL,
  UPDATE_FCL_COUNTER,
  UPDATE_LCL_SHIPMENT,
  SET_SEA_FCL_JSON,
  SET_SEA_LCL_JSON,
  SET_SHOW_RESULT_CARD,
  UPDATE_FORM_LCL_AIR_TYPE,
  SET_AIR_JSON,
  SET_PICKUP_DELIVERY_FACTORY,
  UPDATE_AIR_SHIPMENT,
  SHOW_FORM_VALIDATION,
  SET_SELECTED_EXISTING_FACTORY_JSON,
  SET_DELIVERY_ECOMMERCE_DATA,
  SET_DELIVERY_AMAZON_DATA,
  SAVE_SEARCH_FORM_PARAM,
  FORM_BUTTON_CLICK,
  UPDATE_EXISTING_FACTORY_PIC,
  UPDATE_EXISTING_FACTORY_DEL,
  SET_DELEIVERY_EXISTING_FACTORY, FINAL_VIEW_AFTER_SUBMIT, ADD_NEW_PICKUP_FACTORY, ADD_NEW_DELIVERY_FACTORY, BACK_VIEW_AFTER_SUBMIT,
  CHANGE_FINAL_FORM_VIEW_FALSE,
  CHANGE_FINAL_FORM_BOOKING_VIEW_FALSE,
  CHANGE_BACK_FORM_BOOKING_VIEW_FALSE,
  FINAL_VIEW_AFTER_BOOKING,
  PUBLIC_USER_VIEW_AFTER_SUBMIT,
  CHANGE_PUBLIC_USER_BOOKING_VIEW_FALSE,
  STORE_NEW_ID,

} from './types';

import {
  API_KEY,
  AUTH_TOKEN,
  FORM_SUBMIT_URL,
  FORM_PORT_PICKUP_URL,
  FORM_PICKUP_FACTORY_LIST,
  FORM_PORT_DELIVERY_URL,
  FORM_DELIVERY_FACTORY_LIST,
  FORM_INIT_PICKUP_DELIVERY_URL,
  FORM_DELIVERY_ECOMMERCE_URL,
  FORM_DELIVERY_AMAZON_URL,
} from '../envVariables';

import {
  get_all_ports,
  get_buying_rate,
  get_Client_Rate,
  getScheduleDataFromAPI,
  sendScheduleDataFromAPI,
  updatePortTransitTimeChargeType
} from '../GraphQL/entities'

import {getJSON, postZipCodeData, setSchedule} from './index';

import localFCLJSON from '../data/sea-fcl.json';
// import localFCLJSONTest from '../data/sea-fcl-test.json';
import localLCLJSON from '../data/sea-lcl.json';
import localAIRJSON from '../data/air.json';
import localFactoryListJSON from '../data/factoryList.json';
import localDeliveryEcommerceJSON from '../data/form-delivery-ecommerce.json';
import localPortsJSON from '../data/ports.json';
import localPortsManyJSON from '../data/ports-many.json';

import localFormInitJSON from '../data/form-init-data.json';

import { isEmpty } from '../util/isEmpty';
import { isDevENV } from '../util/isDevENV';
import getNewRatesByUUID from '../util/getNewRatesByUUID';
import { convertToMetric } from '../util/convertToMetric';
import {
  setFormZipCodeSubmitLoading,
  setOverlayFullScreen,
  updateRateCardsInfo,
} from './code_config_actions';
import { getFclOverweightContainer } from '../util/getFclOverweightContainer';
import { checkFcl45hqPrice } from '../util/checkFcl45hqPrice';
import {
  resetSidebarRoleIncoterm,
  updateSidebarRoleIncoterm,
} from '../util/updateSidebarRoleIncoterm';
import { cleanPickupDeliveryJson } from '../util/cleanPickupDeliveryJson';
import Home from "../components/Home";
import {sendNewShipperData, sendNewDeliveryLocationData, sendBookingData, sendbookingDataFromLandingPage, getScheduleData, getDutyAndTaxFromSimplyDuty, getHSCode, sendNewSignUpRequest} from '../GraphQL/entities';
import { setTransparentOverlay } from './code_config_actions';
import { filterScheduleByRecentEtd, fetchRecentByCreatedOrUpdate , isUpdateRequired, calculateAveragePortTransit} from '../util/filterSchedules'
import {updateTransitTime, updatePortToPortTransitTime} from './route_actions'
const LOCAL_SERVER_URL = 'http://localhost:5000/';

// new factoty/selected existing factory fields
const BUSINESS_NAME = 'name';
const EMAIL = 'email';
const POSTAL = 'postal';
const COUNTRY = 'country';
const CITY = 'city';
const ADDRESS = 'address';
const PORT = 'port';

const CONTACT_NAME = 'contact_name';
const PHONE_NUMBER = 'phone_number';
const BUSINESS_TYPE = 'busines_type';

/**
 * @module form_action
 * @redux
 * @description These are redux actions creators related to Form page.
 * @category Form Page
 * @subcategory actions
 */

/**
 * @function
 * @name updateErrorAndLoading
 * @description It updates error message and spinner loading
 * @param {string} [error=''] - error message
 * @param {boolean} [loading=false] - should show loading spinner
 * @returns {Redux.Action} The generated action
 */
export const updateErrorAndLoading =
  (error = '', loading = false) =>
  async (dispatch) => {
    dispatch({ type: UPDATE_ERROR, payload: { error, loading } });
  };

/**
 * @function
 * @name closeModal
 * @description It closes the form modal i.e. doesn't show Form page
 * @returns {Redux.Action} The generated action
 */
export const closeModal = () => async (dispatch) => {
  dispatch({ type: SHOW_FORM, payload: false });
};


export const setFormView=()=>async (dispatch, getstate)=>{
if(getstate().form.final_view_after_submit){
  dispatch({
    type:CHANGE_FINAL_FORM_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.final_view_after_booking){
  dispatch({
    type:CHANGE_FINAL_FORM_BOOKING_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.back_view_after_booking){
  dispatch({
    type:CHANGE_BACK_FORM_BOOKING_VIEW_FALSE,
    payload:false
  })
}
if(getstate().form.public_user_view_after_submit){
  dispatch({
    type:CHANGE_PUBLIC_USER_BOOKING_VIEW_FALSE,
    payload:false
  })
}
}

/**
 * @function
 * @name updateActiveTabpane
 * @description whether LCL/AIR or FCL tab is selected on Form page.
 * `true` - FCL tab is selected. `false` - LCL/AIR tab is selected.
 * @param {boolean} data - whether FCL tab is selected
 * @returns {Redux.Action} The generated action
 */
export const updateActiveTabpane = (data) => async (dispatch) => {
  dispatch({ type: UPDATE_FORM_TAB_PANE, payload: data });
};

/**
 * @function
 * @name updateLclAirType
 * @description  it sets lcl or air mode in pallets/boxes/crates tab on form page.
 * @param {string} data - either `lcl` or `air`
 * @returns {Redux.Action} The generated action
 */
export const updateLclAirType = (data) => (dispatch) => {
  dispatch({ type: UPDATE_FORM_LCL_AIR_TYPE, payload: data });
};

export const Create_New_Booking =(newBooking, booking_charges) =>async (dispatch,getState)=>{
  let jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
  dispatch(setTransparentOverlay(true))
  try {
    const result = await sendBookingData(jwt_token, newBooking, booking_charges);
    dispatch(setTransparentOverlay(false))
    if(result){
      return result
    }else{
      dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    }
   
  } catch (error) {
    console.error("Error:", error);
  }
}

export const Create_New_Booking_Landing_Page =(jwt_token,bookingDataCharges,bookingForm,
  shipperReceiverForm1,shipperReceiverForm2,insuranceArr, dutyTax) =>async (dispatch)=>{
  try {
    const result = await sendbookingDataFromLandingPage(jwt_token,bookingDataCharges,bookingForm,
      shipperReceiverForm1,shipperReceiverForm2,insuranceArr, dutyTax)
    dispatch(setTransparentOverlay(false))
    if(result){
      return result
    }else{
      dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    }
  } catch (error) {
    console.error("Error:", error);
  }
}


export const Create_New_Signup_Request = (jwt_token,form1,form2, bookform,bookingDatacharges) => async (dispatch) =>{
  // console.log("jwt_token: ",jwt_token,"recatcha: ",form1,form2)
  try{
    return await sendNewSignUpRequest(jwt_token,form1,form2,bookform,bookingDatacharges)
  }catch (error) {
    console.error("Error:", error);
  }
}

export const Get_Product_HSCode =(payload) =>async (dispatch, getState)=>{
  try {
    const result = await getHSCode(payload, getState, dispatch);
    if(result[0] && result?.[1]){
      return result[1]
    }else{
      console.log("No HsCode from SimplyDuty API")
    }
  } catch (error) {
    console.error("Error:", error);
  }
  }

export const Get_Duty_And_Tax =(payload) =>async (dispatch,getState)=>{
  try {
    const result = await getDutyAndTaxFromSimplyDuty(payload, getState, dispatch);
    if(result[0] && result?.[1]){
      return result[1]
    }else{
      console.log("No result from SimplyDuty API")
    }
   
  } catch (error) {
    console.error("Error:", error);
  }
}
//part of linescape schedule api...need to be deleted
// const Refresh_Schedules = async (payload, isUserPresent, getState) => {
//   const data={
//       origin_code: payload?.origin?.portCode,
//       destination_code: payload?.discharge?.scac_code,
//       carrier_code: payload?.carrier?.scac_code,
//       routeCode : payload?.route?.name,
//   }

//   try {
//     // Fetch data from schedule API
//     const result = await getScheduleDataFromAPI(data, isUserPresent, getState);
   
//     if (result[0] === 200) {
//       const data = result[1];
//       const routeCode = payload?.route?.name;
//       //console.log("RouteCode / Vessel service: ", payload.route, routeCode);

//       // Extract and format schedule data
//       let scheduleData = data.flatMap(item => {
//         // Filter legs that match the route code
//         const matchingLegs = item.legs.filter(leg =>
//           leg.route.code.includes(routeCode) || leg.route.name.includes(routeCode)
//         );

//         //console.log("matchingLegs: ", matchingLegs);

//         // Check if the last leg matches the route code
//         if (matchingLegs.length > 0 &&
//           (matchingLegs[matchingLegs.length - 1].route.code.includes(routeCode) ||
//             matchingLegs[matchingLegs.length - 1].route.name.includes(routeCode))
//         ) {
//           // Get ETD from the first leg and ETA from the last leg
//           const firstLeg = item.legs[0];
//           const lastLeg = item.legs[item.legs.length - 1];
//           //console.log("firstLeg: ", firstLeg, "lastLeg: ", lastLeg);

//           return {
//             lineScapeScheduleId: firstLeg.schedule_id,
//             voyage: lastLeg.voyage,
//             portTransitTime: item.duration, // Transit time for the entire route
//             etd: firstLeg.start.date, // ETD (Estimated Time of Departure from the first leg)
//             etaPortOfDischarge: lastLeg.end.date, // ETA (Estimated Time of Arrival at Discharge Port from the last leg)
//             vesselName: lastLeg.vessel.name,
//             origin: payload.origin,
//             discharge: payload.discharge,
//             destination: payload.destination
//           };
//         }
//         // Return an empty array to be flattened
//         return [];
//       });

//       //filter the records to check gate-in date (shipment cehcked-in date should be prior to three days os schedule etd date) has been considered
//       const mostRecentRecords = filterScheduleByRecentEtd(scheduleData)
//       scheduleData = mostRecentRecords;
//       //console.log("scheduleData: ",scheduleData);

//       // Store schedule data to database

//       if (scheduleData && scheduleData.length > 0) {
//         //console.log("******* Schedule data is present *******", scheduleData);
//         try{
//           const storeResult = await sendScheduleDataFromAPI(payload, isUserPresent, scheduleData, getState);
//           //console.log("Store result: ", storeResult);
//           if (storeResult[0] === 200 && storeResult[1] //&& storeResult[1].length > 0
//           ) {
//             scheduleData = storeResult[1];
//             return scheduleData
//           }

//         }catch(error){
//           console.error("Error while storing data: ", error);
//         }
//       }
//     }
//   } catch (error) {
//     console.error("Error while getting data: ", error);
//   }
// }

// export const Get_Card_Schedule = (payload, isUserPresent) => async (dispatch, getState) => {
//   const id = payload?.rateCardID
//     try {
//      // const jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
//       const queryParams = getState().route.queryParams
//       const result = await getScheduleData(id, isUserPresent, getState, queryParams, dispatch);
//       //console.log("-- Card_Schedule result from DB --",result)
//       let scheduleData =[];
//       //return scheduleData
//       if (result && result[0] === 200) {
//         scheduleData = result[1]
//         if(payload.buyingRate && scheduleData){
//           // Filter records where vessel_service.id is 3
  
//           const filteredScheduleRecords = scheduleData.filter(schedule => schedule.vessel_service.id === payload.route.id);
//           scheduleData = filteredScheduleRecords
//           const needsUpdate = isUpdateRequired(scheduleData)
//           //console.log(".......needsUpdate.............",needsUpdate)
//           if(needsUpdate){
//             const result = await Refresh_Schedules(payload, isUserPresent, getState);
//             //console.log("Refresh_Schedules , response: ",result);
//             if(result && result.length>0){
//               scheduleData = result
//                //console.log("scheduleData: ",scheduleData);
//             }
//           }
//           //console.log("Before filtering scheduleData: ",scheduleData)
//           const recentSchedules = fetchRecentByCreatedOrUpdate(scheduleData)
//           // console.log("After filtering scheduleData: ",recentSchedules)
//           const averageTT = calculateAveragePortTransit(recentSchedules)
//           const res = await updatePortTransitTimeChargeType(id, averageTT, isUserPresent, getState)

//           if(res && res[0] === 200 && res[1]){
//             const updatedResult = res[1]
//             //console.log("----updatedResult----",updatedResult)
//             if(updatedResult?.portToPortTransitTime){
//               dispatch(updatePortToPortTransitTime(id, updatedResult.portToPortTransitTime, queryParams.type));
//             }
//           }
//           dispatch(setSchedule(id, recentSchedules, queryParams.type))
//           return(recentSchedules)
//         }else if(!payload.buyingRate && scheduleData){
//           //console.log("--- Not Buying rate ---- schedule data --- ",scheduleData)
//           dispatch(setSchedule(id, scheduleData, queryParams.type))
//           return (scheduleData);// Return the result if needed
//         }
//       } 
//       else{
//         return []
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       throw error; // Rethrow the error so it can be caught by the caller if needed
//     }
//   };


// export const Card_Schedule = (id) => async (dispatch, getState) => {
//   try {
//     let jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
//     const result = await getScheduleData(id,jwt_token);
//     if (result[1]) {
//       const data = result[1]
//       let scheduleData ={};
//       if(data[0].buyingRate){
//         scheduleData = data[0]?.schedules
//       }else{
//         scheduleData = data[0]?.buyingLinkedRate?.schedules
//       }
//       dispatch(setCardSchedule(scheduleData));
//       //return [data[0]?.carrier, scheduleData]; 
//       return (scheduleData);// Return the result if needed
//     }
//   } catch (error) {
//     console.error('Error:', error);
//     throw error; // Rethrow the error so it can be caught by the caller if needed
//   }
// };

export const Create_New_Factory=(newfactory,isPickupFactory)=>async (dispatch,getstate)=>{
  try {
   let jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN
   const existingFactoryJson =isPickupFactory? getstate().form.pickup.existingFactoryJson:getstate().form.delivery.existingFactoryJson;

   const consigneeRole = getstate().code_config.transactionType
  let response;
  if(consigneeRole === 'Importer'){
    if(isPickupFactory){
      response = await sendNewShipperData(jwt_token,newfactory,true);
    }else{
      response = await sendNewDeliveryLocationData(jwt_token,newfactory,true);
    }
  }else{
    if(isPickupFactory){
      response = await sendNewDeliveryLocationData(jwt_token,newfactory,true);
    }else{
      response = await sendNewShipperData(jwt_token,newfactory,true);
    }
  }
  if (response.status === 200 && response.data.data.action.results) {
    const newID = response.data.data.action.results
    newfactory.id = newID
    existingFactoryJson.push(newfactory)
    // Dispatch the action to store the newID in Redux
    dispatch(storeNewId(newID));
  }
  if(isPickupFactory){
    dispatch({
      type:ADD_NEW_PICKUP_FACTORY,
      payload:existingFactoryJson
    })
    }
    else {
    dispatch({
      type:ADD_NEW_DELIVERY_FACTORY,
      payload:existingFactoryJson
    })
  }
  } catch(error){
    console.error("Error:", error);
  }
}

export const Update_Factory_select =(selectedFactoryJson,isPickupFactory)=>async (dispatch, getState)=>{
  if(Object.keys(selectedFactoryJson).length > 0){
    selectedFactoryJson.isExistingFactorySelected=true
  }
  if(isPickupFactory){
  dispatch({
    type:SET_PICKUP_EXISTING_FACTORY,
    payload:selectedFactoryJson
  })
  } else {
  dispatch({
    type:SET_DELEIVERY_EXISTING_FACTORY,
    payload:selectedFactoryJson
  })
}

}

export const final_submit_button= (result)=>async (dispatch,getState)=>{
dispatch({
  type: FINAL_VIEW_AFTER_SUBMIT,
  payload: result,

})
}

export const public_user_submit_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: PUBLIC_USER_VIEW_AFTER_SUBMIT,
    payload: result,
  })
}

export const back_submit_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: BACK_VIEW_AFTER_SUBMIT,
    payload: result,
  
  })
  }

export const final_booking_button= (result)=>async (dispatch,getState)=>{
  dispatch({
    type: FINAL_VIEW_AFTER_BOOKING,
    payload: result,
  
  })
  }

  export const storeNewId = (newId) => {
    return {
      type: STORE_NEW_ID,
      payload: newId,
    };
  };



export const Update_In_Existing_Factory =(factory_Json, ispickup)=>async (dispatch,getState)=>{

  const existingFactoryJson =ispickup? getState().form.pickup.existingFactoryJson:getState().form.delivery.existingFactoryJson;
  const index = existingFactoryJson.findIndex(object => object.id === factory_Json.id);

  let jwt_token = getState().route.CLIENT_TOKEN.JWT_TOKEN
let factory_with_index={
    "index":index,
    "updatedValue":factory_Json
}

  if(ispickup){
    dispatch({
      type:UPDATE_EXISTING_FACTORY_PIC,
      payload:factory_with_index
    })
   sendNewShipperData(jwt_token,factory_Json,false);
  }else {
    dispatch({
      type:UPDATE_EXISTING_FACTORY_DEL,
      payload:factory_with_index
    })
   sendNewDeliveryLocationData(jwt_token,factory_Json,false);
  }

}

/**
 * @function
 * @name getFormInitPickupDeliveryData
 * @description It makes network request to get the initial/default pickup/delivery json on form page
 * and saves the data in redux store
 * @returns {Redux.Action} The generated action
 */
export const getFormInitPickupDeliveryData = () => async (dispatch, getState) => {
    // try {
    //   const inputParams = {
    //     apiKey: API_KEY,
    //     Authorization: `Bearer ${AUTH_TOKEN}`,
    //     user: getState().code_config.initAuth.user,
    //     verification: getState().code_config.initAuth.verification,
    //   };
    //
    //   dispatch(updateErrorAndLoading(undefined, true));
    //
    //   let response = {};
    //   // if (isDevENV()) {
    //   //   // response.data = localFormInitJSON;
    //   //   await new Promise((resolve) =>
    //   //     setTimeout(() => {
    //   //       response.data = localFormInitJSON;
    //   //       // console.log('inside timeout');
    //   //       resolve();
    //   //     }, 2000)
    //   //   );
    //   // } else {
    //   //   response = await axios.get(FORM_INIT_PICKUP_DELIVERY_URL, {
    //   //     params: inputParams,
    //   //   });
    //   // }
    //
    //   if (!response.data || isEmpty(response.data)) {
    //     return;
    //   }
    //   // dispatch actions to update redux store
    //   // for pickup
    //   const pickup = response.data.pickup;
    //   // if (pickup && !isEmpty(pickup) && typeof pickup.type_port === 'boolean') {
    //   //   // for port type
    //   //   if (pickup.type_port) {
    //   //     //check if port exist or not
    //   //     dispatch(
    //   //       getRemotePickupData((portJson = undefined) => {
    //   //         // console.log('after pickup port: ', portJson);
    //   //         let tempPickupObj = {};
    //   //         portJson &&
    //   //           Array.isArray(portJson.Ports) &&
    //   //           portJson.Ports.forEach((port) => {
    //   //             if (port.id === pickup.id) {
    //   //               tempPickupObj = port;
    //   //             }
    //   //           });
    //   //         if (tempPickupObj && !isEmpty(tempPickupObj)) {
    //   //           // update pickup id, country, city
    //   //           dispatch({
    //   //             type: SET_FORM_PICKUP_EXTRA,
    //   //             payload: {
    //   //               pickupType: 'port',
    //   //               id: tempPickupObj.id || '',
    //   //               city: tempPickupObj.Name || '',
    //   //               country: tempPickupObj.Country || '',
    //   //             },
    //   //           });
    //   //         }
    //   //       })
    //   //     );
    //   //   } else {
    //   //     // for factory type
    //   //     dispatch(
    //   //       getExistingFactoryPickupData((factoryJson = undefined) => {
    //   //         // console.log('after pickup existing factory');
    //   //         let tempPickupFactoryObj = {};
    //   //         let existingFactoryListArrIndex = null;
    //   //         factoryJson &&
    //   //           Array.isArray(factoryJson.factory_list) &&
    //   //           factoryJson.factory_list.forEach((factory, index) => {
    //   //             if (factory.id === pickup.id) {
    //   //               tempPickupFactoryObj = factory;
    //   //               existingFactoryListArrIndex = index;
    //   //             }
    //   //           });
    //   //         if (tempPickupFactoryObj && !isEmpty(tempPickupFactoryObj)) {
    //   //           // update pickupType to "factory"
    //   //           dispatch({
    //   //             type: SET_FORM_PICKUP_EXTRA,
    //   //             payload: {
    //   //               pickupType: 'factory',
    //   //               selectedExistingFactoryJson: tempPickupFactoryObj,
    //   //             },
    //   //           });
    //   //           // update isExistingFactorySelected, existingFactoryListArrIndex in factoryInfo
    //   //           dispatch(
    //   //             updatePickupDeliveryFactoryInfo({
    //   //               type: 'pickup',
    //   //               data: {
    //   //                 isExistingFactorySelected: true,
    //   //                 existingFactoryListArrIndex,
    //   //               },
    //   //             })
    //   //           );
    //   //         }
    //   //       })
    //   //     );
    //   //   }
    //   // }
    //
    //   // for delivery
    //   // const delivery = response.data.delivery;
    //   // if (
    //   //   delivery &&
    //   //   !isEmpty(delivery) &&
    //   //   typeof delivery.type_port === 'boolean'
    //   // ) {
    //   //   // for port type
    //   //   if (delivery.type_port) {
    //   //     //check if port exist or not
    //   //
    //   //     dispatch(
    //   //       getRemoteDelievryData((portJson = undefined) => {
    //   //         // console.log('after delivery port: ', portJson);
    //   //         let tempDeliveryObj = {};
    //   //         portJson &&
    //   //           Array.isArray(portJson.Ports) &&
    //   //           portJson.Ports.forEach((port) => {
    //   //             if (port.id === delivery.id) {
    //   //               tempDeliveryObj = port;
    //   //             }
    //   //           });
    //   //
    //   //         if (tempDeliveryObj && !isEmpty(tempDeliveryObj)) {
    //   //           // update delivery id, country, city
    //   //           // console.log({ tempDeliveryObj });
    //   //
    //   //           dispatch({
    //   //             type: SET_FORM_DELIVERY_EXTRA,
    //   //             payload: {
    //   //               deliveryType: 'port',
    //   //               id: tempDeliveryObj.id || '',
    //   //               city: tempDeliveryObj.Name || '',
    //   //               country: tempDeliveryObj.Country || '',
    //   //             },
    //   //           });
    //   //         }
    //   //       })
    //   //     );
    //   //   } else {
    //   //     // for factory type
    //   //     dispatch(
    //   //       getExistingFactoryDeliveryData((factoryJson = undefined) => {
    //   //         // console.log('after delivery existing factory');
    //   //         let tempDeliveryFactoryObj = {};
    //   //         let existingFactoryListArrIndex = null;
    //   //         factoryJson &&
    //   //           Array.isArray(factoryJson.factory_list) &&
    //   //           factoryJson.factory_list.forEach((factory, index) => {
    //   //             if (factory.id === delivery.id) {
    //   //               tempDeliveryFactoryObj = factory;
    //   //               existingFactoryListArrIndex = index;
    //   //             }
    //   //           });
    //   //         if (tempDeliveryFactoryObj && !isEmpty(tempDeliveryFactoryObj)) {
    //   //           dispatch({
    //   //             type: SET_FORM_DELIVERY_EXTRA,
    //   //             payload: {
    //   //               deliveryType: 'factory',
    //   //               selectedExistingFactoryJson: tempDeliveryFactoryObj,
    //   //             },
    //   //           });
    //   //           // update isExistingFactorySelected, existingFactoryListArrIndex in factoryInfo
    //   //           dispatch(
    //   //             updatePickupDeliveryFactoryInfo({
    //   //               type: 'delivery',
    //   //               data: {
    //   //                 isExistingFactorySelected: true,
    //   //                 existingFactoryListArrIndex,
    //   //               },
    //   //             })
    //   //           );
    //   //         }
    //   //       })
    //   //     );
    //   //   }
    //   // }
    //
    //   dispatch(updateErrorAndLoading(undefined, undefined));
    // } catch (err) {
    //   console.log(err);
    //   dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    // }
  };

/**
 * @function
 * @name updateFclShipping
 * @description  It updates fcl shipping data in redux store on Form page.
 * @param {number} rowId - It's the `id` of added load in fcl shipping section
 * @param {Object} dataJson - It's the object contains info about added load in Fcl shipping section.
 * @returns {Redux.Action} The generated action
 */
export const updateFclShipping =
  (rowId, dataJson) => async (dispatch, getState) => {
    dispatch({
      type: SET_FORM_FCL_SHIPPING,
      payload: { id: rowId, data: dataJson },
    });
  };

/**
 * @function
 * @name deleteFclShipping
 * @description  It deletes one of added fcl shipping load on Form page.
 * @param {number} rowId - It's the `id` of added load to be deleted
 * @returns {Redux.Action} The generated action
 */
export const deleteFclShipping = (rowId) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_FCL_SHIPPING,
    payload: { id: rowId },
  });
};

/**
 * @function
 * @name updateLclShipppingType
 * @description  Whether boxes/pallets or total shipment shipping is selected on LCL mode on form page.
 * @param {boolean} data - whether box/pallet is selected
 * @returns {Redux.Action} The generated action
 */
export const updateLclShipppingType = (data) => async (dispatch) => {
  dispatch({ type: TOGGLE_LCL_SHIPPING_TYPE, payload: data });
};

/**
 * @function
 * @name updateLclTotalShippment
 * @description  It updates lcl or air total shipment on Form page.
 * @param {Object} data - it contains info about total shipment
 * @returns {Redux.Action} The generated action
 */
export const updateLclTotalShippment = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_LCL_TOTAL_SHIPMENT, payload: data });
};

/**
 * @function
 * @name updateLclBoxPallet
 * @description  It updates lcl box/pallet data on Form page.
 * @param {number} rowId - `id` of the added single box/pallet load
 * @param {Object} dataJson - it contains info about added single box/pallet load
 * @returns {Redux.Action} The generated action
 */
export const updateLclBoxPallet =
  (rowId, dataJson) => async (dispatch, getState) => {
    // console.log("dataJson: ", dataJson);

    dispatch({
      type: SET_LCL_BOX_PALLET,
      payload: { id: rowId, data: dataJson },
    });
  };

/**
 * @function
 * @name deleteLclBoxPallet
 * @description   It deletes lcl box/pallet data on Form page.
 * @param {number} rowId - `id` of the single box/pallet load to be deleted
 * @returns {Redux.Action} The generated action
 */
export const deleteLclBoxPallet = (rowId) => async (dispatch, getState) => {
  dispatch({
    type: DELETE_LCL_BOX_PALLET,
    payload: { id: rowId },
  });
};

/**
 * @function
 * @name getRemotePickupData
 * @description   It gets pickup ports json for Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemotePickupData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        // response.data = localPortsJSON;
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localPortsJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PORT_PICKUP_URL, {
          params: inputParams,
        });
      }
      // console.log('pickup response: ', response.data);

      dispatch({ type: SET_FORM_PICKUP_JSON, payload: response.data });
      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name getExistingFactoryPickupData
 * @description  It gets pickup existing factory list json on Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getExistingFactoryPickupData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      // console.log("existing factory json response: ", response.data);
      if (isDevENV()) {
        // response.data = localFactoryListJSON; //comment this line, it was for testing
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localFactoryListJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PICKUP_FACTORY_LIST, {
          params: inputParams,
        });
      }

      dispatch({
        type: SET_PICKUP_EXISTING_FACTORY,
        payload: response.data,
      });

      dispatch(updateErrorAndLoading(undefined, undefined));
      if (callback) {
        callback(response.data);
      }
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name updatePickupData
 * @description  It updates pickup section data in redux store on Form page.
 * @param {Object} data - It contains info about pickup
 * @returns {Redux.Action} The generated action
 */
export const updatePickupData = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_FORM_PICKUP_EXTRA, payload: data });
};

/**
 * @function
 * @name updateSelectedExistingFactoryPickup
 * @description  It updates pickup selected Existing Factory in redux store on Form page.
 * @param {Object} data - selected existing factory object
 * @returns {Redux.Action} The generated action
 */
export const updateSelectedExistingFactoryPickup =
  (data) => async (dispatch, getState) => {
    dispatch({ type: SET_PICKUP_SELECTED_EXISTING_FACTORY, payload: data });
  };

/**
 * @function
 * @name getRemoteDelievryData
 * @description   It gets delivery ports json for Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDelievryData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        // response.data = localPortsManyJSON;
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localPortsManyJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_PORT_DELIVERY_URL, {
          params: inputParams,
        });
      }

      // console.log("response: ", response.data);

      dispatch({ type: SET_FORM_DELIVERY_JSON, payload: response.data });
      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name getRemoteDeliveryEcommerceData
 * @description It gets E-commerce json in delivery destination location type on form page
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDeliveryEcommerceData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localDeliveryEcommerceJSON;
            resolve();
          }, 500)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_ECOMMERCE_URL, {
          params: inputParams,
        });
      }
      // console.log('ecommerce response: ', response.data);

      dispatch(saveDeliveryEcommerceData({ ecommerceJson: response.data }));

      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name saveDeliveryEcommerceData
 * @description It updates delivery selected e-commerce mode data in redux store on Form page.
 * @param {Object} ecommerceModeObj - e-commerce mode object
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const saveDeliveryEcommerceData =
  (ecommerceModeObj, callback = undefined) =>
  async (dispatch) => {
    // console.log('ecommerce response: ', ecommerceModeObj);

    dispatch({
      type: SET_DELIVERY_ECOMMERCE_DATA,
      payload: ecommerceModeObj,
    });
  };

/**
 * @function
 * @name getRemoteDeliveryAmazonData
 * @description It gets Amazon json in delivery destination location type on form page
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getRemoteDeliveryAmazonData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      if (isDevENV()) {
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localDeliveryEcommerceJSON;
            resolve();
          }, 500)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_AMAZON_URL, {
          params: inputParams,
        });
      }
      // console.log('amazon response: ', response.data);

      dispatch(saveDeliveryAmazonData({ amazonJson: response.data }));

      if (callback) {
        callback(true);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name saveDeliveryAmazonData
 * @description It updates delivery selected amazon mode data in redux store on Form page.
 * @param {Object} amazonModeObj - it contains info about selected amazon mode
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const saveDeliveryAmazonData =
  (amazonModeObj, callback = undefined) =>
  async (dispatch) => {
    // console.log('amazon response: ', amazonModeObj);

    dispatch({
      type: SET_DELIVERY_AMAZON_DATA,
      payload: amazonModeObj,
    });
  };

/**
 * @function
 * @name updatePickupDeliveryFactoryInfo
 * @description It sets whether existing factory is selected or not, and selected existing factory array index
 * in dropdown for both pickup and delivery existing/new factory on form page
 * @param {Object} data - it contains info about pickup/delivery factory info
 * @returns {Redux.Action} The generated action
 */
export const updatePickupDeliveryFactoryInfo = (data) => (dispatch) => {
  dispatch({ type: SET_PICKUP_DELIVERY_FACTORY, payload: data });
};

/**
 * @function
 * @name updatePickupDeliverySelectedExistingFactory
 * @description it updates port/other data to selected Existing Factory Json for pickup/delivery on form page.
 * @param {Object} dataObj - it contains info about pickup/delivery selected existing factory
 * @returns {Redux.Action} The generated action
 */
export const updatePickupDeliverySelectedExistingFactory =
  (dataObj) => (dispatch) => {
    dispatch({
      type: SET_SELECTED_EXISTING_FACTORY_JSON,
      payload: dataObj,
    });
  };

/**
 * @function
 * @name getExistingFactoryDeliveryData
 * @description  It gets delivery existing factory list json on Form page.
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getExistingFactoryDeliveryData =
  (callback = undefined) =>
  async (dispatch, getState) => {
    try {
      const inputParams = {
        apiKey: API_KEY,
        Authorization: `Bearer ${AUTH_TOKEN}`,
        user: getState().code_config.initAuth.user,
        verification: getState().code_config.initAuth.verification,
      };

      dispatch(updateErrorAndLoading(undefined, true));

      let response = {};
      // console.log("existing factory json response: ", response.data);
      if (isDevENV()) {
        //response.data = localFactoryListJSON; //comment this line, it was for testing
        await new Promise((resolve) =>
          setTimeout(() => {
            response.data = localFactoryListJSON;
            resolve();
          }, 100)
        );
      } else {
        response = await axios.get(FORM_DELIVERY_FACTORY_LIST, {
          params: inputParams,
        });
      }

      dispatch({
        type: SET_DELIVERY_EXISTING_FACTORY,
        payload: response.data,
      });

      if (callback) {
        callback(response.data);
      }

      dispatch(updateErrorAndLoading(undefined, undefined));
    } catch (err) {
      console.log(err);
      if (callback) {
        callback();
      }
      dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
    }
  };

/**
 * @function
 * @name updateDeliveryData
 * @description  It updates delivery section data in redux store on Form page.
 * @param {Object} data - It contains info about delivery
 * @returns {Redux.Action} The generated action
 */
export const updateDeliveryData = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_FORM_DELIVERY_EXTRA, payload: data });
};

/**
 * @function
 * @name updateSelectedExistingFactoryDelivery
 * @description  It updates delivery selected Existing Factory in redux store on Form page.
 * @param {Object} data - selected existing factory object
 * @returns {Redux.Action} The generated action
 */
export const updateSelectedExistingFactoryDelivery =
  (data) => async (dispatch, getState) => {
    // dispatch({ type: SET_DELIVERY_SELECTED_EXISTING_FACTORY, payload: data });
  };

/**
 * @function
 * @name saveCustomService
 * @description  It saves custom service section data in redux store on Form page.
 * @param {Object} data - it contains info about custom service
 * @returns {Redux.Action} The generated action
 */
export const saveCustomService = (data) => async (dispatch) => {
  dispatch({ type: SET_FORM_CUSTOM_SERVICE, payload: data });
};

/**
 * @function
 * @name updateLoadSummaryText
 * @description  It creates summary text and saves it in redux store on Form page.
 * @returns {Redux.Action} The generated action
 */
export const updateLoadSummaryText = () => async (dispatch, getState) => {
  const isFclTabActive = getState().form.isFclTabActive;

  if (isFclTabActive) {
    let noOfContainers = 0;
    const fclShipping = getState().form.fclShipping;

    Object.keys(fclShipping).forEach((key) => {
      let input = fclShipping[key] && fclShipping[key].input;
      if (input) {
        noOfContainers += input;
      }
    });
    dispatch({
      type: SET_LOAD_SUMMARY_TEXT,
      payload: `Total: ${noOfContainers} Containers`,
    });
  } else {
    // for lcl
    const { summaryText } = calculateLclAirShipment(getState);

    dispatch({
      type: SET_LOAD_SUMMARY_TEXT,
      payload: summaryText,
    });
  }
};

export const updateLoadSummaryLCL = () => async (dispatch, getState) => {
  // for lcl
  const data = calculateLclLoadShipment(getState);
  dispatch({
    type: SET_LOAD_SUMMARY_LCL,
    payload: data,
  });
};

/**
 * @function
 * @name resetContainersTypeSliders
 * @description It resets selected [LCL container info]{@Link LCLContainerType} and [LCL/AIR shipment]{@Link LclAirSlider} info in sidebar.
 * @returns {Redux.Action} The generated action
 */
export const resetContainerLCLSliders = () => (dispatch, getState) => {
  const lclAirShippingLCL = getState().form.lclAirShipping
  const k = 0;
  // Loop through the boxPallet array starting from the index after the first record
  for (let i = k + 1; i < Object.keys(lclAirShippingLCL.boxPallet).length; i++) {
    // Delete the record using deleteLclBoxPallet function
    deleteLclBoxPallet(i);
  }
  dispatch({ type: RESET_LOAD_SUMMARY_LCL, payload: {} });
};

const calculateLclLoadShipment = (getState) => {
  let summaryText;
  const lclAirShipping = getState().form.lclAirShipping;
  const lclShipment = getState().code_config.lclShipment

  // for summary text
  let quantity = 0;
  let summaryVol = 0.0;
  let summaryVolUnit = lclShipment.volumeUnit;
  let summaryWt = 0.0;
  let summaryWtUnit = lclShipment.weightUnit;

  const boxPallet = lclAirShipping.boxPallet;
  let midUnit = lclShipment.volumeUnit; // final unit of dimens

  Object.keys(boxPallet || {}).forEach((key) => {
    const boxPalletRow = boxPallet[key];
    if (!boxPalletRow) {
      return;
    }
    quantity += boxPalletRow.quantity;
    const weight = (boxPalletRow.totalWeight && boxPalletRow.totalWeight!=='') ? parseFloat(boxPalletRow.totalWeight) : 0
    const volume = (boxPalletRow.totalVolume && boxPalletRow.totalVolume!=='') ? parseFloat(boxPalletRow.totalVolume) : 0

    if ((boxPalletRow.wtUnit === 'LB' && (lclShipment.weightUnit === 'LBS' || lclShipment.weightUnit === 'LB')) || (boxPalletRow.wtUnit === 'KG' && lclShipment.weightUnit === 'KG')){
      summaryWt += weight;
      summaryVol += volume;
    }else{
      if(lclShipment.weightUnit === 'KG' && boxPalletRow.wtUnit ==='LB')
      {
        summaryWt += parseFloat((weight / 2.205 ).toFixed(2));
        summaryVol += parseFloat((volume / 35.315).toFixed(2));
      }
      else if ( (lclShipment.weightUnit === 'LB' || lclShipment.weightUnit === 'LBS') && boxPalletRow.wtUnit ==='KG')
      {
        summaryWt += parseFloat((weight * 2.205).toFixed(2));
        summaryVol += parseFloat((volume * 35.315).toFixed(2));
      }
    }
  }); //end of loop

  summaryVolUnit = midUnit;

  summaryVol = isNaN(summaryVol) ? 0 : parseFloat(summaryVol).toFixed(2);
  summaryWt = isNaN(summaryWt) ? 0 : parseFloat(summaryWt).toFixed(2);
  summaryText = `Total: ${quantity} Units, ${summaryVolUnit}: ${summaryVol || 0} ,${summaryWtUnit}: ${summaryWt || 0} `;

  const lclLoadSummary={
    weight: summaryWt,
    volume: summaryVol,
    quantity: quantity
  }
  return { summaryText, lclLoadSummary };
};

/**
 * @typedef {Object} calculateLclAirShipmentReturnType
 * @property {string} summaryText - summary text e.g. `Total: 1 Units, 2.00 CBM, 2.00 KG`
 * @property {Object} lclAirShipmentFormSubmit - lcl air shipment info e.g. `{quantity, totalWeight, weightUnit, totalVolume, volumeUnit}`
 */

/**
 * @function
 * @name calculateLclAirShipment
 * @description  It saves custom service section data in redux store on Form page.
 * @param {Redux.State} getState - whole redux state
 * @returns {calculateLclAirShipmentReturnType} [See here]{@link module:form_action~calculateLclAirShipmentReturnType}
 */
const calculateLclAirShipment = (getState) => {
  let summaryText;
  // let summaryBoxPalletJson = {};
  let lclAirShipmentFormSubmit = {};
  const isLclBoxPalletSelected = getState().form.isLclBoxPalletSelected;
  const lclAirShipping = getState().form.lclAirShipping;

  // for summary text
  let quantity = 0;
  let summaryVol = 0.0;
  let summaryVolUnit = 'CBM';
  let summaryWt = 0.0;
  let summaryWtUnit = 'KG';

  if (isLclBoxPalletSelected) {
    // console.log("Lcl Box Pallet");
    const boxPallet = lclAirShipping.boxPallet;

    //let weight = 0;
    let weightUnit = 'KG';

    //let midVol = 0.0; //final volume of all rows dimens
    let midUnit = 'CBM'; // final unit of dimens

    Object.keys(boxPallet || {}).forEach((key) => {
      const boxPalletRow = boxPallet[key];

      if (!boxPalletRow) {
        return;
      }

      const rowQuantity = boxPalletRow.quantity;

      quantity += boxPalletRow.quantity;

      if (weightUnit === 'KG') {
        if (boxPalletRow.wtUnit === 'KG') {
          // new row in 'KG', old row(KG)
          //weight += parseFloat(boxPalletRow.wtValue || 0);
          weightUnit = boxPalletRow.wtUnit;
          //summary wt
          summaryWt += parseFloat(boxPalletRow.wtValue || 0) * rowQuantity;
        } else {
          // new row in 'LB', then convert old row(KG) to LB then add it to new row
          // weight = parseFloat(boxPalletRow.wtValue || 0) + parseFloat(weight * 2.205);
          weightUnit = boxPalletRow.wtUnit;

          //summary wt
          summaryWt =
            parseFloat(boxPalletRow.wtValue || 0) * rowQuantity +
            parseFloat(summaryWt * 2.205);
        }
      } else if (weightUnit === 'LB') {
        if (boxPalletRow.wtUnit === 'KG') {
          // new row in 'KG', then convert old row(LB) to KG then add it to new row
          //const tempWt = parseFloat(weight / 2.205).toFixed(2);
          // weight = parseFloat(boxPalletRow.wtValue || 0) + parseFloat(tempWt);
          weightUnit = boxPalletRow.wtUnit;
          //summary wt
          const tempSummaryWt = parseFloat(summaryWt / 2.205).toFixed(2);
          summaryWt =
            parseFloat(boxPalletRow.wtValue || 0) * rowQuantity +
            parseFloat(tempSummaryWt);
        } else {
          // new row in 'LB',old row(LB)
          //weight += parseFloat(boxPalletRow.wtValue || 0);
          weightUnit = boxPalletRow.wtUnit;

          //summary wt
          summaryWt += parseFloat(boxPalletRow.wtValue || 0) * rowQuantity;
        }
      }
      summaryWtUnit = weightUnit;

      let dimenUnit = boxPalletRow.dimenUnit;
      let dimenLeftValue = boxPalletRow.dimenLeftValue || 0;
      let dimenMidValue = boxPalletRow.dimenMidValue || 0;
      let dimenRightValue = boxPalletRow.dimenRightValue || 0;

      let tempVol = dimenLeftValue * dimenMidValue * dimenRightValue;

      let tempFinalVol;
      if (midUnit === 'CBM') {
        //for mid cbm or cft
        if (dimenUnit === 'CM') {
          //Cubic Metres(CBM)
          tempFinalVol = parseFloat(tempVol / 1000000).toFixed(2);
          midUnit = 'CBM';
          //summary volume
          summaryVol =
            parseFloat(tempFinalVol) * rowQuantity + parseFloat(summaryVol);
          summaryVol = Number(summaryVol);
        } else {
          //IN
          //Cubic Feet(CFT)
          //convert CBM to CFT  for old cummulative value
          //midVol = parseFloat(midVol * 35.315).toFixed(2);
          tempFinalVol = parseFloat(tempVol / 1728).toFixed(2);
          midUnit = 'CFT';
          //summary volume
          summaryVol =
            Number(parseFloat(tempFinalVol) * rowQuantity) +
            Number(parseFloat(summaryVol * 35.315).toFixed(2));
        }
        //let tempAllVal = parseFloat(tempFinalVol) + parseFloat(midVol);
        //midVol = parseFloat(tempAllVal).toFixed(2);
      } else if (midUnit === 'CFT') {
        //for mid cbm or cft
        if (dimenUnit === 'CM') {
          //Cubic Metres(CBM)
          //convert CFT to CBM  for old cummulative value
          //midVol = parseFloat(midVol / 35.315).toFixed(2);
          tempFinalVol = parseFloat(tempVol / 1000000).toFixed(2);
          midUnit = 'CBM';
          //summary volume
          // console.log({ rowQuantity, summaryVol });
          summaryVol =
            Number(parseFloat(tempFinalVol) * rowQuantity) +
            Number(parseFloat(summaryVol / 35.315).toFixed(2));
        } else {
          //IN
          //Cubic Feet(CFT)
          tempFinalVol = parseFloat(tempVol / 1728).toFixed(2);
          midUnit = 'CFT';
          //summary volume
          summaryVol =
            parseFloat(tempFinalVol) * rowQuantity + parseFloat(summaryVol);
          summaryVol = Number(summaryVol);
        }
        //let tempAllVal = parseFloat(tempFinalVol) + parseFloat(midVol);
        //midVol = parseFloat(tempAllVal).toFixed(2);
      }
    }); //end of loop
    summaryVolUnit = midUnit;

    //midVol = parseFloat(midVol).toFixed(2);
    //weight = parseFloat(weight).toFixed(2);

    //for only form POST request params
    // summaryBoxPalletJson = {
    //   quantity,
    //   volume: midVol || 0,
    //   volumeUnit: midUnit,
    //   weight,
    //   weightUnit,
    // };
  } else {
    // console.log("Lcl total shippment");
    const totalShipment = lclAirShipping.totalShipment;

    quantity = totalShipment.quantity;

    summaryVol = totalShipment.totalVolume;
    summaryVolUnit = totalShipment.volumeUnit;

    summaryWt = totalShipment.totalWeight;
    summaryWtUnit = totalShipment.weightUnit;
  }

  summaryVol = parseFloat(summaryVol).toFixed(2);
  summaryVol = isNaN(summaryVol) ? 0 : summaryVol;
  summaryWt = parseFloat(summaryWt).toFixed(2);
  summaryWt = isNaN(summaryWt) ? 0 : summaryWt;

  summaryText = `Total: ${quantity} Units, ${
    summaryVol || 0
  } ${summaryVolUnit}, ${summaryWt || 0} ${summaryWtUnit}`;

  lclAirShipmentFormSubmit = {
    quantity,
    totalWeight: Number(summaryWt) || 0,
    weightUnit: summaryWtUnit,
    totalVolume: Number(summaryVol) || 0,
    volumeUnit: summaryVolUnit,
  };

  // convert to metric for search bar page
  lclAirShipmentFormSubmit = convertToMetric(lclAirShipmentFormSubmit);

  // return { summaryText, lclAirShipmentFormSubmit, summaryBoxPalletJson };
  return { summaryText, lclAirShipmentFormSubmit };
};

/**
 * @function
 * @name submitForm
 * @description it submits the Form when Search & Book button is clicked
 * @param {number} data - it is only used for next-step check whether all next-step's button have been clicked
 * @returns {Redux.Action} The generated action
 */
export const submitForm = (data) => async (dispatch, getState) => {

  //check for next-steps
  let showFormCustomService = getState().code_config.showFormCustomService;
  if (getState().form.isFclTabActive) {
    //fcl
    if (data < (showFormCustomService ? 2 : 1)) {
      dispatch(
        updateErrorAndLoading("Go through all the 'NEXT STEP's", undefined)
      );
      return;
    }
  } else {
    //lcl or air
    if (data < (showFormCustomService ? 3 : 2)) {
      dispatch(
        updateErrorAndLoading("Go through all the 'NEXT STEP's", undefined)
      );
      return;
    }
  }

  try {
    // for validation in pickup, delivery selects
    dispatch({ type: SHOW_FORM_VALIDATION, payload: true });
    // if (!isDevENV()) {
    //   if (areEmptyFieldsPresent(dispatch, getState)) {
    //     return;
    //   }
    // }

    const inputParams = {
      apiKey: API_KEY,
      Authorization: `Bearer ${AUTH_TOKEN}`,
      user: getState().code_config.initAuth.user,
      verification: getState().code_config.initAuth.verification,
      referral_code: getState().code_config.referralData.referral_code,
      referral_type: getState().code_config.referralData.referral_type,
      form_params: buildFormParamsBeforeSubmit(getState) || {}, //uncommennt this
      object_type: 'rate_search',
    };

    console.log('for submit inputParams: ', inputParams);

    await doAfterFormSubmit(dispatch, getState,inputParams);

    inputParams.form_params.pickup={}
    inputParams.form_params.delivery={}
    inputParams.form_params.pickup.selectedPort=getState().route.queryParams.from
    inputParams.form_params.delivery.selectedPort=getState().route.queryParams.to
    inputParams.form_params.pickup.date=getState().route.queryParams.date
    inputParams.form_params.type = getState().route.queryParams.type


    // dispatch(updateErrorAndLoading(undefined, true));
    // show overlay
    dispatch(setOverlayFullScreen(true));

    let response = {};
    let data_from_graphql={}

    data_from_graphql=await get_Client_Rate(getState,inputParams,false,dispatch)
    if(data_from_graphql.status!=="200"){
      updateErrorAndLoading(data_from_graphql.error, undefined)
    }else {
      response.data=data_from_graphql.response
      // if(response.data!==undefined){
        response.data=data_from_graphql.response
          if(response.data === undefined){
            response.data={}
            // dispatch({type:FORM_BUTTON_CLICK,payload:true})
            // dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true }); // for home page fileds become read only
            // dispatch({ type: SHOW_FORM, payload: false }); // hide form, uncomment this
            // // dispatch({ type: SET_SHOW_RESULT_CARD, payload: false });

            // console.log(response.data)
          }
      console.log(response)

      // if (isDevENV()) {
        //   response.data = {};
        //   await new Promise((resolve) => setTimeout(() => resolve(), 500));
        // } else {
        //   response = await axios.post(FORM_SUBMIT_URL, {
        //     params: inputParams,
        //   });
        // }

        // if (!response.data) {
        //   return;
        // }

        // reset sidebar services
        resetSidebarRoleIncoterm(dispatch);

        if (getState().form.isFclTabActive) {
          console.log("For FCL")
          //fcl
          // if (isDevENV()) {
          //   // response.data = localFCLJSON; //comment this line, it was for testing
          //   // console.log('dev localFCLJSON');
          //   // response.data = localFCLJSONTest;
          // }
          //
          response.data = checkFcl45hqPrice(response.data);
          //
          dispatch({
            type: SET_SEA_FCL_JSON,
            payload: response.data,
          });
        } else {
          if (getState().form.lclAirShipping.type === 'lcl') {
            console.log("For LCL")

            //lcl
            // if (isDevENV()) {
            //   response.data = localLCLJSON; //comment this line, it was for testing
            //   // console.log('dev localLCLJSON');
            // }
            //
            dispatch({
              type: SET_SEA_LCL_JSON,
              payload: response.data,
            });
          } else {
            //air
            console.log("For LCL Air")

            // if (isDevENV()) {
            //   response.data = localAIRJSON; //comment this line, it was for testing
            //   // console.log('dev localAIRJSON');
            // }
            // dispatch({ type: SET_AIR_JSON, payload: response.data });
          }
        }

        // reset rate cards state whether cards are expanded or not
        dispatch(updateRateCardsInfo(null));

        // update sidebar checkboxes based on all cards
        updateSidebarRoleIncoterm(response.data, dispatch);


        // to show when no rates are found
        // dispatch({
        //   type: SAVE_SEARCH_FORM_PARAM,
        //   payload: { response, show: true },
        // });


        // for data polling
        //don't do data polling byuuid if on landing page
        // console.log('Home dataPolling?: ', dataPolling);
        // if (getState().code_config.dataPolling) {
        //   console.log("in polling")
        //   // console.log('should do data polling: ', dataPolling);
        //   // get new rate + old rate
        //   // it will also remove old timer id regardless of whether uuid present or not
        //   await getNewRatesByUUID(
        //     getState().route.queryParams,
        //     response.data,
        //     dispatch,
        //     getState
        //   );
        // }



        // this.getJSON()
        // console.log(this.props)
        // this.state.route.getJSON
        dispatch({type:FORM_BUTTON_CLICK,payload:true})
        dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true }); // for home page fileds become read only
        dispatch({ type: SHOW_FORM, payload: false }); // hide form, uncomment this
      if(response.data.rates!==undefined){
        dispatch({ type: SET_SHOW_RESULT_CARD, payload: false });
      }else{
        dispatch({
          type: SET_SHOW_RESULT_CARD,
          payload: isEmpty(response.data),
        });
        let object={
          form_params:inputParams.form_params,
          show:true
        }

        dispatch({
          type:SAVE_SEARCH_FORM_PARAM,
          payload:object
        })
      }


        // dispatch(updateErrorAndLoading(undefined, undefined));
        //
        // // make zip code request for new/existing factory
        // postFormFactoryZipCode(dispatch, getState);

      // }else{
      //   dispatch(updateErrorAndLoading(JSON.stringify(data_from_graphql.error), undefined));
      //   // dispatch({ type: SET_SHOW_RESULT_CARD, payload: isEmpty(response.data),});
      // }

    }

  } catch (err) {
    console.log(err);
    dispatch({ type: SHOW_FORM, payload: true });
    dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
  }
  // hide overlay
  dispatch(setOverlayFullScreen(false));
};

/**
 * @function
 * @name areEmptyFieldsPresent
 * @description It checks whether empty form fields are present or not, upon click on 'search & book' on Form page.
 * @param {Function} dispatch - redux dispatch
 * @param {Redux.State} getState - whole redux state
 * @returns {boolean} `true` - empty form fields are present. `false` - no empty fields are found
 */
const areEmptyFieldsPresent = (dispatch, getState) => {
  //date
  let date = getState().form.pickup.date;
  if (!date) {
    dispatch(updateErrorAndLoading('"date" is empty', undefined));
    return true;
  }

  //from, pickup
  if (getState().form.pickup.pickupType === 'port') {
    if (!getState().form.pickup.city || !getState().form.pickup.country) {
      dispatch(
        updateErrorAndLoading(
          'Pickup fields are empty. Fill out all of them.',
          undefined
        )
      );
      return true;
    }
  } else {
    //factory
    let isExistingFactorySelected =
      getState().form.factoryInfo.pickup.isExistingFactorySelected;

    let selectedExistingFactoryJson =
      getState().form.pickup.selectedExistingFactoryJson || {};

    let newfactoryData = getState().form.factoryInfo.pickup.newFactory;

    // selectedExistingFactoryJson.port = {}; //comment this line

    // pickup existing factory checks
    if (isExistingFactorySelected) {
      // port
      if (
        !selectedExistingFactoryJson[PORT] ||
        isEmpty(selectedExistingFactoryJson[PORT])
      ) {
        dispatch(updateErrorAndLoading('pickup "port" is empty', undefined));
        return true;
      }
      // postal
      if (
        !selectedExistingFactoryJson[POSTAL] ||
        isEmpty(selectedExistingFactoryJson[POSTAL])
      ) {
        dispatch(updateErrorAndLoading('pickup "postal" is empty', undefined));
        return true;
      }

      if (
        !selectedExistingFactoryJson.address ||
        !selectedExistingFactoryJson.city ||
        !selectedExistingFactoryJson.country ||
        !selectedExistingFactoryJson.postal ||
        !selectedExistingFactoryJson.name ||
        (!selectedExistingFactoryJson.email &&
          !selectedExistingFactoryJson[PHONE_NUMBER]) ||
        !selectedExistingFactoryJson.port ||
        !selectedExistingFactoryJson[BUSINESS_TYPE] ||
        !selectedExistingFactoryJson[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Pickup fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    } else {
      //new factory checks
      if (
        !newfactoryData.address ||
        !newfactoryData.city ||
        !newfactoryData.country ||
        !newfactoryData.postal ||
        !newfactoryData.name ||
        (!newfactoryData.email && !newfactoryData[PHONE_NUMBER]) ||
        !newfactoryData.port ||
        !newfactoryData[BUSINESS_TYPE] ||
        !newfactoryData[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Pickup fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    }
  }

  //to, delivery
  if (getState().form.delivery.deliveryType === 'port') {
    if (!getState().form.delivery.city && !getState().form.delivery.country) {
      dispatch(
        updateErrorAndLoading(
          'Delivery fields are empty. Fill out all of them.',
          undefined
        )
      );
      return true;
    }
  } else if (getState().form.delivery.deliveryType === 'factory') {
    //factory
    let isExistingFactorySelected =
      getState().form.factoryInfo.delivery.isExistingFactorySelected;

    let selectedExistingFactoryJson =
      getState().form.delivery.selectedExistingFactoryJson || {};

    let newfactoryData = getState().form.factoryInfo.delivery.newFactory;

    // selectedExistingFactoryJson.port = {}; //comment this line

    //delivery existing factory checks
    if (isExistingFactorySelected) {
      // port
      if (
        !selectedExistingFactoryJson[PORT] ||
        isEmpty(selectedExistingFactoryJson[PORT])
      ) {
        dispatch(updateErrorAndLoading('delivery "port" is empty', undefined));
        return true;
      }
      // postal
      if (
        !selectedExistingFactoryJson[POSTAL] ||
        isEmpty(selectedExistingFactoryJson[POSTAL])
      ) {
        dispatch(
          updateErrorAndLoading('delivery "postal" is empty', undefined)
        );
        return true;
      }

      if (
        !selectedExistingFactoryJson.address ||
        !selectedExistingFactoryJson.city ||
        !selectedExistingFactoryJson.country ||
        !selectedExistingFactoryJson.postal ||
        !selectedExistingFactoryJson.name ||
        (!selectedExistingFactoryJson.email &&
          !selectedExistingFactoryJson[PHONE_NUMBER]) ||
        !selectedExistingFactoryJson.port ||
        !selectedExistingFactoryJson[BUSINESS_TYPE] ||
        !selectedExistingFactoryJson[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Delivery fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    } else {
      //new factory checks
      if (
        !newfactoryData.address ||
        !newfactoryData.city ||
        !newfactoryData.country ||
        !newfactoryData.postal ||
        !newfactoryData.name ||
        (!newfactoryData.email && !newfactoryData[PHONE_NUMBER]) ||
        !newfactoryData.port ||
        !newfactoryData[BUSINESS_TYPE] ||
        !newfactoryData[CONTACT_NAME]
      ) {
        dispatch(
          updateErrorAndLoading(
            'Delivery fields are empty. Fill out all of them.',
            undefined
          )
        );
        return true;
      }
    }
  } else if (getState().form.delivery.deliveryType === 'ecommerce') {
    const selectedEcommerceJson =
      getState().form.delivery.ecommerceMode.selectedEcommerceJson;
    if (!selectedEcommerceJson || isEmpty(selectedEcommerceJson)) {
      dispatch(updateErrorAndLoading('Select an ecommerce factory', undefined));
      return true;
    }
  } else if (getState().form.delivery.deliveryType === 'amazon') {
    const selectedAmazonJson =
      getState().form.delivery.amazonMode.selectedAmazonJson;
    if (!selectedAmazonJson || isEmpty(selectedAmazonJson)) {
      dispatch(updateErrorAndLoading('Select an amazon factory', undefined));
      return true;
    }
    const boxSelection = getState().form.delivery.amazonMode.boxSelection;
    const palletSelection = getState().form.delivery.amazonMode.palletSelection;

    if (!boxSelection || isEmpty(palletSelection)) {
      dispatch(
        updateErrorAndLoading(
          'Select all destination amazon packing requirements',
          undefined
        )
      );
      return true;
    }
  }

  if (getState().form.isFclTabActive) {
    //fcl
    let _20stCounter = 0;
    let _40stCounter = 0;
    let _40hqCounter = 0;
    const fclShipping = getState().form.fclShipping;

    Object.keys(fclShipping).forEach((key) => {
      let input = fclShipping[key] && fclShipping[key].input;
      let type = fclShipping[key] && fclShipping[key].type;
      if (input) {
        if (type === "20'") _20stCounter += input;
        else if (type === "40'") {
          _40stCounter += input;
        } else if (type === "40'HC") {
          _40hqCounter += input;
        }
      }
    });
    if (!_20stCounter && !_40stCounter && !_40hqCounter) {
      dispatch(updateErrorAndLoading('Add a Container', undefined));
      return true;
    }
  } else {
    //lcl
    const { lclAirShipmentFormSubmit } = calculateLclAirShipment(getState);
    let { totalWeight, weightUnit, totalVolume, volumeUnit } =
      lclAirShipmentFormSubmit;

    // console.log(
    //   'lclAirShipmentFormSubmit: wt, vol,',
    //   Number(totalWeight),
    //   Number(totalVolume)
    // );
    totalWeight = Number(totalWeight) || 0;
    totalVolume = Number(totalVolume) || 0;

    // console.log('totalWeight', totalWeight, ', totalVolume', totalVolume);

    if (!totalWeight || !totalVolume) {
      dispatch(
        updateErrorAndLoading('weight or volume field is empty/zero', undefined)
      );
      return true;
    }
  }

  return false; // no empty field found
};

/**
 * @function
 * @name cleanBoxPalletArr
 * @description It removes unnecessary properties from each and every
 *  single box/pallet added load and convert units to required units. It's only used in form submit params.
 * @param {Array.<Object>} boxPalletArr - box pallet added loads need to be cleaned
 * @returns {Array.<Object>} new cleaned box pallet array of loads
 */
const cleanBoxPalletArr = (boxPalletArr) => {
  const newBoxPalletArr = boxPalletArr.map((row) => {
    const tempRow = row && {
      packageType: row.packageType,

      quantity: row.quantity,

      dimenUnit: row.dimenUnit,
      dimenLVal: row.dimenLeftValue,
      dimenWVal: row.dimenMidValue,
      dimenHVal: row.dimenRightValue,

      wtValue: row.wtValue,
      wtUnit: row.wtUnit,
    };
    if (tempRow.wtUnit === 'LB') {
      //convert to KG
      tempRow.wtValue = parseFloat(tempRow.wtValue / 2.205).toFixed(2);
      tempRow.wtUnit = 'KG';
    }
    if (tempRow.dimenUnit === 'IN') {
      //convert to CM
      tempRow.dimenLVal = parseFloat(tempRow.dimenLVal * 2.54).toFixed(2);
      tempRow.dimenWVal = parseFloat(tempRow.dimenWVal * 2.54).toFixed(2);
      tempRow.dimenHVal = parseFloat(tempRow.dimenHVal * 2.54).toFixed(2);
      tempRow.dimenUnit = 'CM';
    }
    //volum in cm^3

    tempRow.totalVolume = parseFloat(
      (tempRow.dimenLVal * tempRow.dimenWVal * tempRow.dimenHVal) / 1000000
    ).toFixed(2);
    tempRow.totalVolumeUnit = 'CBM';

    return tempRow;
  });

  return newBoxPalletArr;
};

/**
 * @function
 * @name buildFormParamsBeforeSubmit
 * @description It builds form submit params to be sent to remote server.
 * @param {Redux.State} getState - whole redux state
 * @returns {Object}  form submit params
 */
const buildFormParamsBeforeSubmit = (getState) => {
  let params = {};
  if (getState().code_config.showFormCustomService) {
    params.customService = getState().form.customService;
  }

  params.pickup = cleanPickupDeliveryJson(getState, 'pickup').newDataJson;
  params.delivery = cleanPickupDeliveryJson(getState, 'delivery').newDataJson;

  params.factoryInfo = getState().form.factoryInfo;
  if (getState().form.isFclTabActive) {
    //fcl
    params.isFclSelected = true;
    params.type = 'api-fcl';
    let tempFclShipping = getState().form.fclShipping || {};
    // make fclShipping object to array
    let tempFclShippingArr = [];
    if (!isEmpty(tempFclShipping)) {
      let keys = Object.keys(tempFclShipping).filter(
        (key) => tempFclShipping[key] && key
      );

      keys.map((key) => tempFclShippingArr.push(tempFclShipping[key]));
    }
    // console.log('tempFclShippingArr', tempFclShippingArr);

    params.fclShipping = tempFclShippingArr;
    // add total number of overweight containers
    params.overweightContainer = getFclOverweightContainer(getState);
  } else {
    //lcl or air
    params.type =
      getState().form.lclAirShipping.type === 'lcl' ? 'api-lcl' : 'api-air';
    // let tempQuantity;
    // let tempVolume;
    // let tempVolumeUnit;
    // let tempWt;
    // let tempWtUnit;

    if (getState().form.isLclBoxPalletSelected) {
      //box-pallet
      params.isBoxPalletSelected = true;
      let tempBoxPallet = getState().form.lclAirShipping.boxPallet || {};
      // make boxPallet object to array
      if (!isEmpty(tempBoxPallet)) {
        let keys = Object.keys(tempBoxPallet).filter(
          (key) => tempBoxPallet[key] && key
        );
        tempBoxPallet = keys.map((key) => tempBoxPallet[key]);
      }
      //clean boxPallet array here
      params.boxPallet = cleanBoxPalletArr(tempBoxPallet);

      // const {
      //   summaryBoxPalletJson: {
      //     quantity,
      //     volume,
      //     volumeUnit,
      //     weight,
      //     weightUnit,
      //   },
      // } = calculateLclAirShipment(getState);
      // tempQuantity = quantity;
      // tempVolume = volume;
      // tempVolumeUnit = volumeUnit;
      // tempWt = weight;
      // tempWtUnit = weightUnit;
    } else {
      //total shipment
      params.isBoxPalletSelected = false;
      // const {
      //   quantity,
      //   totalVolume,
      //   volumeUnit,
      //   totalWeight,
      //   weightUnit,
      // } = getState().form.lclAirShipping.totalShipment;
      // tempQuantity = quantity;
      // tempVolume = totalVolume;
      // tempVolumeUnit = volumeUnit;
      // tempWt = totalWeight;
      // tempWtUnit = weightUnit;
    }

    // if (tempVolumeUnit === 'CFT') {
    //   //convert to CBM
    //   tempVolume = parseFloat(tempVolume / 1728).toFixed(2);
    //   tempVolumeUnit = 'CBM';
    // }
    // if (tempWtUnit === 'LB') {
    //   //convert to KG
    //   tempWt = parseFloat(tempWt / 2.205).toFixed(2);
    //   tempWtUnit = 'KG';
    // }

    // params.total_shipment = {
    //     quantity: tempQuantity,
    //     totalVolume: tempVolume,
    //     volumeUnit: tempVolumeUnit,
    //     totalWeight: tempWt,
    //     weightUnit: tempWtUnit,
    // };

    params.total_shipment =
      calculateLclAirShipment(getState).lclAirShipmentFormSubmit;
  }

  // console.log('before submitted params: ', params);

  return params;
};

/**
 * @function
 * @name getQueryParams
 * @description After form data is submitted,
 * this method gets `type` and `date` and these will be saved in query params in redux store.
 * @param {Redux.State} getState - whole redux state
 * @returns {Object}
 * @example
 * console.log(getQueryParams(getState));
 *
 * //output
 * {
 * type: 'api-air',
 * date: '12 May, 2020'
 * }
 */
const getQueryParams = (getState) => {
  let params = {};
  //type i.e. api-fcl or api-lcl
  if (getState().form.isFclTabActive) {
    params.type = 'api-fcl';
  } else {
    if (getState().form.lclAirShipping.type === 'lcl') {
      params.type = 'api-lcl';
    } else {
      params.type = 'api-air';
    }
  }
  //date
  params.date = getState().form.pickup.date;

  return params;
};

/**
 * @function
 * @name doAfterFormSubmit
 * @description After the form is successfully submitted,
 * it updates queryParams, FCL type  containers numbers or LCL/AIR shipment in redux store.
 * @param {Function} dispatch - redux dispatch
 * @param {Redux.State} getState - whole redux state
 * @returns {void}
 */

const set_factor_object=async (factory_object, type,getState)=>{
  let port={}
  let origin_json=getState().route.originPortJSON.Ports
  let delivery_json=getState().route.destinationPortJSON.Ports
  port.id=factory_object.port.id
  if(type==="delivery"){
    port=delivery_json.filter((object,index)=>{
      if(object.id===port.id){
        return object
      }
    })
  }else {
    port=origin_json.filter((object,index)=>{
      if(object.id===port.id){
        return object
      }
    })
  }

  return port[0]

}
const doAfterFormSubmit = async (dispatch, getState,inputParams) => {
  /*form-submit-success to true, show-form  to false as it's already done
   * add params to home page and make it only read-only
   * make search btn disable
   */

  //update queryParams
  // let pickupPort = cleanPickupDeliveryJson(
  //   getState,
  //   'pickup'
  // ).selectedPortForSearchPage;
  // pickupPort = {
  //   ...pickupPort,
  //   name: pickupPort.city || pickupPort.name || '',
  // };
  //
  let pickupPort={}
  let deliveryPort={}
  if(inputParams.form_params.pickup.pickupType==="factory"){
    let factory_object=inputParams.form_params.pickup.selectedExistingFactoryJson[0]
    pickupPort=await set_factor_object(factory_object,"pickup",getState)
  }else {
    pickupPort=inputParams.form_params.pickup.selectedPort
  }

  if(inputParams.form_params.delivery.deliveryType==="factory"){
    let factory_object=inputParams.form_params.delivery.selectedExistingFactoryJson[0]
    deliveryPort=await set_factor_object(factory_object,"delivery",getState)
  }else {
    deliveryPort=inputParams.form_params.delivery.selectedPort
  }


  // let deliveryPort = cleanPickupDeliveryJson(
  //   getState,
  //   'delivery'
  // ).selectedPortForSearchPage;
  // deliveryPort = {
  //   ...deliveryPort,
  //   name: deliveryPort.city || deliveryPort.name || '',
  // };


  const queryParams = {
    ...getQueryParams(getState),
    from: pickupPort,
    to: deliveryPort,
  };
  console.log('form queryParams', queryParams);

  dispatch({ type: SET_QUERY_PARAMS, payload: queryParams });
  //update fcl containers
  //update lcl volume, weight and units

  // if (getState().form.isFclTabActive) {
  //   //fcl
  //   let _20stCounter = 0;
  //   let _40stCounter = 0;
  //   let _40hqCounter = 0;
  //   let _45hqCounter = 0;
  //   const fclShipping = getState().form.fclShipping;
  //
  //   Object.keys(fclShipping).forEach((key) => {
  //     let input = fclShipping[key] && fclShipping[key].input;
  //     let type = fclShipping[key] && fclShipping[key].type;
  //     if (input) {
  //       if (type === "20'") {
  //         _20stCounter += input;
  //       } else if (type === "40'") {
  //         _40stCounter += input;
  //       } else if (type === "40'HC") {
  //         _40hqCounter += input;
  //       } else if (type === "45'HC") {
  //         _45hqCounter += input;
  //       }
  //     }
  //   });
  //
  //   // console.log("counters: ", _20stCounter, _40stCounter, _40hqCounter);
  //
  //   dispatch({
  //     type: UPDATE_FCL_COUNTER,
  //     payload: { _20stCounter, _40stCounter, _40hqCounter, _45hqCounter },
  //   });
  // } else {
  //   //lcl or air
  //
  //   //lcl
  //   const { lclAirShipmentFormSubmit } = calculateLclAirShipment(getState);
  //   // console.log('lclAirShipmentFormSubmit', lclAirShipmentFormSubmit);
  //
  //   if (getState().form.lclAirShipping.type === 'lcl') {
  //     dispatch({
  //       type: UPDATE_LCL_SHIPMENT,
  //       payload: lclAirShipmentFormSubmit,
  //     });
  //   } else {
  //     //air
  //     dispatch({
  //       type: UPDATE_AIR_SHIPMENT,
  //       payload: lclAirShipmentFormSubmit,
  //     });
  //   }
  // }
  //air

  // console.log('form store states: ', getState().form);
};

/**
 * @function
 * @name postFormFactoryZipCode
 * @description After the form is successfully submitted,
 * make [zip code]{@link module:route_action~postZipCodeData} request,
 * get postal from pickup/delivery new/existing factory
 * @param {Function} dispatch - redux dispatch
 * @param {Redux.State} getState - whole redux state
 * @returns {void}
 */
const postFormFactoryZipCode = (dispatch, getState) => {
  // console.log('postFormPickupDeliveryZipCode ****************');

  const formState = getState().form;

  const pickupType = formState.pickup.pickupType;
  const deliveryType = formState.delivery.deliveryType;

  // check whether it's in factory mode
  // for pickup
  if (pickupType === 'factory' || isDevENV()) {
    const isExistingFactorySelected =
      formState.factoryInfo.pickup.isExistingFactorySelected;
    let zipCode;

    if (!!isExistingFactorySelected) {
      // existing factory
      zipCode = formState.pickup.selectedExistingFactoryJson.postal;
    } else {
      // new factory
      zipCode = formState.factoryInfo.pickup.newFactory.postal;
    }

    const pickupFactoryPostalObj = {
      mode: 'pickup',
      zipCode: isDevENV() ? '123test pickup' : zipCode,
      optionId: Date.now() + Math.ceil(Math.random() * 100 + 10),
    };
    // console.log({ pickupFactoryPostalObj });

    dispatch(postZipCodeData(pickupFactoryPostalObj, undefined, true));
    // enable form zip code loading
    dispatch(
      setFormZipCodeSubmitLoading({
        isPickupLoading: true,
      })
    );
  }

  // for delivery
  if (
    deliveryType === 'factory' ||
    deliveryType === 'ecommerce' ||
    deliveryType === 'amazon' ||
    isDevENV()
  ) {
    const isExistingFactorySelected =
      formState.factoryInfo.delivery.isExistingFactorySelected;

    let zipCode;

    if (!!isExistingFactorySelected) {
      // existing factory
      zipCode = formState.delivery.selectedExistingFactoryJson.postal;
    } else {
      // new factory
      zipCode = formState.factoryInfo.delivery.newFactory.postal;
    }

    // for delivery type of ecommerce or amazon  mode
    if (deliveryType === 'ecommerce' || deliveryType === 'amazon') {
      zipCode = cleanPickupDeliveryJson(getState, 'delivery').newDataJson
        .selectedExistingFactoryJson.postal;
      // console.log('ecommerce or amazon mode, postal in modes: ', zipCode);
    }

    const deliveryFactoryPostalObj = {
      mode: 'delivery',
      zipCode: isDevENV() ? '123test delivery' : zipCode,
      optionId: Date.now() + Math.ceil(Math.random() * 100 + 10),
    };
    // console.log({ deliveryFactoryPostalObj });

    dispatch(postZipCodeData(deliveryFactoryPostalObj, undefined, true));
    // enable form zip code loading
    dispatch(
      setFormZipCodeSubmitLoading({
        isDeliveryLoading: true,
      })
    );
  }
};

/**
 * @function
 * @name toggleFormModalVisibility
 * @description It's for showing/hiding form modal when back/edit button is clicked on search bar page.
 * @returns {Redux.Action} The generated action
 */
export const toggleFormModalVisibility = () => async (dispatch, getState) => {
  if (getState().form.isFormSubmitSuccess) {
    dispatch({ type: SHOW_FORM, payload: true });
    dispatch({ type: FORM_SUBMIT_SUCCESS, payload: true });
  }
};
